import React, { useState } from 'react';
import { Pie } from 'react-chartjs-2';
import 'chart.js/auto';
import '../sip/Calculators.css';

const LumpSumCalculator = () => {
  const [investment, setInvestment] = useState(100000);
  const [months, setMonths] = useState(120);
  const [rate, setRate] = useState(14);
  const [result, setResult] = useState(null);

  const calculateLumpSum = () => {
    const years = months / 12;
    const maturityAmount = investment * Math.pow(1 + rate / 100, years);
    const growthAmount = maturityAmount - investment;

    setResult({
      maturityAmount: maturityAmount.toFixed(0),
      growthAmount: growthAmount.toFixed(0),
    });
  };

  const pieData = result && {
    labels: ['Principal', 'Growth'],
    datasets: [
      {
        data: [investment, result.growthAmount],
        backgroundColor: ['#004aad', '#76d041'],
      },
    ],
  };

  return (
    <div className="sip-calculator">
      <h2>Lump Sum Calculator</h2>

      <div className="input-group">
        <label>Investment Amount</label>
        <input
          type="range"
          min="0"
          max="150000000"
          step="1000"
          value={investment}
          onChange={(e) => setInvestment(Number(e.target.value))}
        />
        <input
          type="number"
          min="0"
          max="150000000"
          value={investment}
          onChange={(e) => {
            const val = e.target.value;
            setInvestment(val === '' ? '' : Number(val));
          }}
          className="value-box"
        />
      </div>

      <div className="input-group">
        <label>Duration (In Months)</label>
        <input
          type="range"
          min="1"
          max="600"
          step="1"
          value={months}
          onChange={(e) => setMonths(Number(e.target.value))}
        />
        <input
          type="number"
          min="1"
          max="600"
          value={months}
          onChange={(e) => {
            const val = e.target.value;
            setMonths(val === '' ? '' : Number(val));
          }}
          className="value-box"
        />
      </div>

      <div className="input-group">
        <label>Growth Rate (%)</label>
        <input
          type="range"
          min="0"
          max="100"
          step="0.1"
          value={rate}
          onChange={(e) => setRate(Number(e.target.value))}
        />
        <input
          type="number"
          min="0"
          max="100"
          value={rate}
          onChange={(e) => {
            const val = e.target.value;
            setRate(val === '' ? '' : Number(val));
          }}
          className="value-box"
        />
      </div>

      <button onClick={calculateLumpSum} className="calculate-btn">
        Calculate
      </button>

      {result && (
        <div className="sip-output-section">
          <div className="result-summary">
            <h3>Lump Sum Results</h3>
            <p>Maturity Value: <span>₹ {result.maturityAmount}</span></p>
            <p>Principal Invested: <span>₹ {investment.toLocaleString()}</span></p>
            <p>Growth Amount: <span>₹ {result.growthAmount}</span></p>
          </div>

          <div className="pie-chart-container">
            <h3>Principal vs Growth</h3>
            <Pie data={pieData} />
          </div>
        </div>
      )}
    </div>
  );
};

export default LumpSumCalculator;
